var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_1445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0591 2.19661C15.9184 0.372391 12.7349 0.700516 10.77 2.72786L10.0005 3.52083L9.23095 2.72786C7.27001 0.700516 4.08251 0.372391 1.94189 2.19661C-0.51124 4.29036 -0.640146 8.04817 1.55517 10.3177L9.11376 18.1224C9.60204 18.6263 10.395 18.6263 10.8833 18.1224L18.4419 10.3177C20.6411 8.04817 20.5122 4.29036 18.0591 2.19661Z",
    fill: "#E11E35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_1445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.4fb05b41a95142ddc70069a9ce610148.svg";
export { ForwardRef as ReactComponent };